import {
  TRACK_CHECKLIST_ASSESSMENT_PAGE_VIEWED,
  SECTION_TO_PAGE_VIEWED_EVENT_MAP,
  TRACK_CHECKLIST_GENERAL_CONDITIONS_CLOSE_BUTTON_CLICKED,
  TRACK_CHECKLIST_GENERAL_CONDITIONS_FINISH_BUTTON_CLICKED,
  TRACK_CHECKLIST_ASSESSMENT_CONFIRMATION_PAGE_VIEWED,
  TRACK_CHECKLIST_GENERAL_CONDITIONS_FINISH_CONFIRMED,
  TRACK_CHECKLIST_GENERAL_CONDITIONS_ERROR_CTA_VIEWED,
  TRACK_CHECKLIST_GENERAL_CONDITIONS_DOUBTS_BUTTON_CLICKED,
  TRACK_CHECKLIST_USEFUL_INFORMATION_BUTTON_CLICKED,
} from 'containers/PropertyAssessment/constants';

import { logWithDefaultProperties } from '../defaultLogger';
import { PAGE_NAMES } from '../constants';

export const handlePropertyAssessmentActions = (amplitudeInstance, action) => {
  switch (action.type) {
    case TRACK_CHECKLIST_ASSESSMENT_PAGE_VIEWED:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PROPERTY_ASSESSMENT,
        eventName:
          SECTION_TO_PAGE_VIEWED_EVENT_MAP[action.eventProperties.sectionId],
        extraProperties: {
          house_id: action.eventProperties.houseId,
          house_area: action.eventProperties.houseArea,
        },
      });
      break;

    case TRACK_CHECKLIST_GENERAL_CONDITIONS_CLOSE_BUTTON_CLICKED:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PROPERTY_ASSESSMENT,
        eventName: 'checklist_general_conditions_close_button_clicked',
        extraProperties: {
          house_id: action.eventProperties.houseId,
          house_area: action.eventProperties.houseArea,
          current_page: action.eventProperties.currentPage,
          category: action.eventProperties.category,
        },
      });
      break;

    case TRACK_CHECKLIST_GENERAL_CONDITIONS_FINISH_BUTTON_CLICKED:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PROPERTY_ASSESSMENT,
        eventName: 'checklist_general_conditions_finish_button_clicked',
        extraProperties: {
          house_id: action.eventProperties.houseId,
          house_area: action.eventProperties.houseArea,
        },
      });
      break;

    case TRACK_CHECKLIST_ASSESSMENT_CONFIRMATION_PAGE_VIEWED:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PROPERTY_ASSESSMENT,
        eventName:
          'checklist_general_conditions_finish_confirmation_page_viewed',
        extraProperties: {
          house_id: action.eventProperties.houseId,
          house_area: action.eventProperties.houseArea,
        },
      });
      break;

    case TRACK_CHECKLIST_GENERAL_CONDITIONS_FINISH_CONFIRMED:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PROPERTY_ASSESSMENT,
        eventName: 'checklist_general_conditions_finish_confirmed',
        extraProperties: {
          house_id: action.eventProperties.houseId,
          house_area: action.eventProperties.houseArea,
        },
      });
      break;

    case TRACK_CHECKLIST_GENERAL_CONDITIONS_ERROR_CTA_VIEWED:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PROPERTY_ASSESSMENT,
        eventName: 'checklist_general_conditions_error_cta_viewed',
        extraProperties: {
          house_id: action.eventProperties.houseId,
          house_area: action.eventProperties.houseArea,
          current_page: action.eventProperties.currentPage,
          category: action.eventProperties.category,
          error_type: action.eventProperties.errorType,
        },
      });
      break;

    case TRACK_CHECKLIST_GENERAL_CONDITIONS_DOUBTS_BUTTON_CLICKED:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PROPERTY_ASSESSMENT,
        eventName: 'checklist_general_conditions_doubts_button_clicked',
        extraProperties: {
          house_id: action.eventProperties.houseId,
          house_area: action.eventProperties.houseArea,
          current_page: action.eventProperties.currentPage,
          category: action.eventProperties.category,
        },
      });
      break;

    case TRACK_CHECKLIST_USEFUL_INFORMATION_BUTTON_CLICKED:
      logWithDefaultProperties({
        amplitudeInstance,
        pageName: PAGE_NAMES.PROPERTY_ASSESSMENT,
        eventName: 'checklist_useful_information_button_clicked',
        extraProperties: {
          useful: action.eventProperties.useful,
          checklist_item: action.eventProperties.checklistItem,
          category: action.eventProperties.category,
        },
      });
      break;

    default:
      break;
  }
};

export default handlePropertyAssessmentActions;
